// extracted by mini-css-extract-plugin
export default {"wrap":"RateOfCorrectAnswer_wrap__tEAKr","hide":"RateOfCorrectAnswer_hide__nOQX8"};